import React from "react";

import styled from "styled-components";

interface PrimarySecondaryIndicatorProps {
  isPrimary: boolean;
  isSecondary: boolean;
  onSetPrimary: (e: React.MouseEvent) => void;
  onSetSecondary: (e: React.MouseEvent) => void;
  isPrimaryDisabled?: boolean;
  isSecondaryDisabled?: boolean;
}

export function PrimarySecondaryIndicator({
  isPrimary,
  isSecondary,
  onSetPrimary,
  onSetSecondary,
  isPrimaryDisabled = false,
  isSecondaryDisabled = false
}: PrimarySecondaryIndicatorProps) {
  if (isPrimaryDisabled && isSecondaryDisabled) return null;

  const handleDisabledClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <>
      <BadgeButton
        className={`ps-indicator-btn${
          isPrimary && !isPrimaryDisabled ? " isActive" : ""
        }${isPrimaryDisabled ? " isDisabled" : ""} primaryProduct`}
        onClick={isPrimaryDisabled ? handleDisabledClick : onSetPrimary}
        aria-label="Set primary axis">
        P
      </BadgeButton>
      <BadgeButton
        className={`ps-indicator-btn${
          isSecondary && !isSecondaryDisabled ? " isActive" : ""
        }${isSecondaryDisabled ? " isDisabled" : ""} secondaryProduct`}
        onClick={isSecondaryDisabled ? handleDisabledClick : onSetSecondary}
        aria-label="Set secondary axis">
        S
      </BadgeButton>
    </>
  );
}

const BadgeButton = styled.div`
  position: absolute;
  top: -5px;
  left: -1px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #f2f5f5;
  background: white;
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  transition: all var(--duration-short) ease;

  &.isActive {
    opacity: 1;
    background: var(--color-primary);
    color: white;
  }

  &:hover {
    background: var(--color-primary);
    color: white;
  }

  &.secondaryProduct {
    left: auto;
    right: -1px;
    border-color: var(--color-primary-hover);
    color: var(--color-primary-hover);

    &:hover,
    &.isActive {
      background: var(--color-primary-hover);
      color: white;
    }
  }

  &.isDisabled {
    background: #d1d5d6;
    color: white;
    border-color: #d1d5d6;
    cursor: not-allowed;

    &:hover {
      background: #d1d5d6;
      color: white;
    }
  }
`;
